import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { strings } from '../../../../localization';
import globals from '../../../common/globals';


export default class BeaconAddModal extends Component {
    render() {
        const emailAddress = globals.supportEmail;
        return (
            <Modal isOpen={this.props.isOpen}
                contentLabel="beacon-add-modal"
                className="beacon-add-modal react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={false}
                onRequestClose={this.props.onCancel}>
                <div className="container-fluid form-card">
                    <h2>{strings.beacons_beacon_add_modal_header}</h2>
                    <div className="row">
                        <div className="col-12">
                            <p>{strings.beacons_beacon_add_modal_content} <a href={`mailto:${emailAddress}`} target='_blank' rel='noopener noreferrer'>{emailAddress}</a></p>
                        </div>
                        <div className="col-12 action-btns text-center">
                            <button className="btn btn-outline-blue" onClick={this.props.onCancel}><i className="material-icons">close</i>{strings.app_close}</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
        
    }
}

BeaconAddModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};